import styled from 'styled-components'
import * as All from '../BaseStyles'

export const ComponentsDiv = styled(All.ComponentsDiv)`
    bottom: 0rem;
    height: 100vh;
    overflow-y: initial;
    overflow-x: scroll;
`
